import { defineStore } from 'pinia'

export const useShopStore = defineStore('ShopStore', {
  state: () => ({
    allProducts: [],
    allProductsCount: 0,
    allCategories: [],
    isLoading: false,
    itemsPerPage: 1,
    loadMore: true,
    skipItems: 0,
    isEmpty: false,
    allFilters: [],
    allFiltersCount: 0
  }),
  getters: {
    getCategoryByName(state) {
      return (catName: string) => state.allCategories.find((cat) => cat.title === catName)
    }
  },
  actions: {
    async fetchArticles(locale: string, filter?: any) {
      this.setLoading(true)

      const { data } = await useAsyncGql('shopProducts', {
        locale,
        first: this.itemsPerPage,
        skip: this.skipItems,
        eq: filter,
        options: {
          initialCache: false
        }
      })

      this.allProductsCount = data?.value!._allShopProductsMeta.count

      if (data?.value!._allShopProductsMeta.count === 0) {
        this.setEmpty(true)
      } else {
        this.setEmpty(false)
      }

      const results = data?.value!.allShopProducts
      if (results.length > 0) {
        this.allProducts.push(...results)
        this.skipItems += results.length
      }

      this.setLoadMore()

      this.setLoading(false)
    },
    pushCategories(payload: any) {
      this.allCategories = payload
    },
    pushFilters(query: string) {
      this.allFilters = query
      this.allFiltersCount = 1
    },
    setItemsPerPage(amount: number) {
      this.itemsPerPage = amount
    },
    setLoading(bool: boolean) {
      this.isLoading = bool
    },
    setLoadMore() {
      this.loadMore = this.skipItems < this.allProductsCount
    },
    setEmpty(bool: boolean) {
      this.isEmpty = bool
    },
    resetArticles() {
      this.allProducts = []
      this.allProductsCount = 0
      this.skipItems = 0
    }
  }
})
